import React from "react";
import { Switch as AntSwitch, type SwitchProps as AntSwitchProps } from "antd";
import classNames from "classnames";
import styles from "../../style/components/switch.module.scss";

export type SwitchTheme = "primary";

interface CustomSwitchProps {
  theme?: SwitchTheme;
  label?: string;
  labelPosition?: "left" | "right";
  showLabel?: boolean;
  onChange?: (checked: boolean) => void;
}

interface SwitchProps
  extends Omit<AntSwitchProps, "onChange">,
    CustomSwitchProps {}

const SwitchComponent: React.FC<SwitchProps> = ({
  theme = "primary",
  label,
  labelPosition = "left",
  showLabel = false,
  className = "",
  onChange,
  ...props
}) => {
  const switchClasses = classNames(
    styles.switch,
    styles[`theme-${theme}`],
    {
      [styles.disabled]: props.disabled,
    },
    className
  );

  const handleChange = (checked: boolean) => {
    onChange?.(checked);
  };

  const switchElement = (
    <AntSwitch className={switchClasses} {...props} onChange={handleChange} />
  );

  if (!showLabel || !label) {
    return switchElement;
  }

  return (
    <div className={styles.switchContainer}>
      {labelPosition === "left" && (
        <label className={styles.label}>{label}</label>
      )}
      {switchElement}
      {labelPosition === "right" && (
        <label className={styles.label}>{label}</label>
      )}
    </div>
  );
};

export default SwitchComponent;

